"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberGenerator = void 0;
const crypto_1 = require("crypto");
const detect_environment_1 = require("../detect-environment");
class NumberGenerator {
    generate() {
        const env = (0, detect_environment_1.detectEnvironment)();
        if (env === detect_environment_1.Environment.NODEJS) {
            return (0, crypto_1.randomInt)(0, 1000000);
        }
        const typedArray = new Uint32Array(1);
        window.crypto.getRandomValues(typedArray);
        const randomIntStr = typedArray[0].toString();
        return Number(randomIntStr.slice(0, 6));
    }
}
exports.NumberGenerator = NumberGenerator;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibnVtYmVyLWdlbmVyYXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlsL2hhc2gtZ2VuZXJhdG9yL251bWJlci1nZW5lcmF0b3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQW1DO0FBQ25DLDhEQUF1RTtBQUd2RSxNQUFhLGVBQWU7SUFDakIsUUFBUTtRQUNYLE1BQU0sR0FBRyxHQUFHLElBQUEsc0NBQWlCLEdBQUUsQ0FBQztRQUVoQyxJQUFJLEdBQUcsS0FBSyxnQ0FBVyxDQUFDLE1BQU0sRUFBRSxDQUFDO1lBQzdCLE9BQU8sSUFBQSxrQkFBUyxFQUFDLENBQUMsRUFBRSxPQUFPLENBQUMsQ0FBQztRQUNqQyxDQUFDO1FBRUQsTUFBTSxVQUFVLEdBQUcsSUFBSSxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDdEMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxlQUFlLENBQUMsVUFBVSxDQUFDLENBQUM7UUFFMUMsTUFBTSxZQUFZLEdBQUcsVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUFDLFFBQVEsRUFBRSxDQUFDO1FBRTlDLE9BQU8sTUFBTSxDQUFDLFlBQVksQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDNUMsQ0FBQztDQUNKO0FBZkQsMENBZUMifQ==